import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/providers/AppProviders";
import { ShellSkeleton } from "@/components/shell/AppShell";

// Layout guard for every authenticated route.
//
// Two rules that together close the redirect trap:
//  1. While the session is still resolving we render the SHELL SKELETON, never the
//     app and never the login page. Rendering either one first is what causes the
//     flash-then-bounce; the skeleton has the shell's exact geometry, so the real
//     shell replaces it without moving anything.
//  2. An unauthenticated visitor goes to /login -- NOT to "/" and not to
//     "/dashboard". Both of those are guarded routes, so sending them there would
//     bounce straight back here and loop forever.
//
// `state.from` carries the originally requested URL so Login can return the operator
// to where they were actually headed instead of dumping everyone on the dashboard.
export function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <ShellSkeleton />;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  // An account an invitation created signs in with a temporary password its inviter also
  // knows, so every path leads to /set-password until its holder picks their own. The API
  // refuses everything else anyway (core/deps.py); letting them past would only paint a
  // shell full of 403s.
  if (user.must_change_password && location.pathname !== "/set-password") {
    return <Navigate to="/set-password" replace />;
  }

  return <Outlet />;
}
